import React, { Component } from 'react';
import { Modal, Button, Spin } from 'antd';
import TableC from '../../basicElement/TableC'
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class DetailModal extends Component {
    state = {
        type: '',
        data: [],
        record: {},
        visible: false,
        loading: false,
        pagination: {
            current: 1,
            pageSize: 5,
        },
    }

    show = (type, record) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            type,
            record,
            pagination,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { type, record, pagination } = this.state;
        const { pageSize, current } = pagination;
        const { cityId, yearMonth } = record;
        this.setState({ loading: true });
        let url;
        const params = {};
        if (type === 'crcNum' || type === 'aboveSupervisorNum' || type === 'crcAddNum' || type === 'newEmployeeNum') {
            url = API_URL.user.getUserList;
            if (type === 'crcNum') {
                params.type = 'CRC';
            } else if (type === 'aboveSupervisorNum') {
                params.type = 'SUPERVISOR';
            } else if (type === 'crcAddNum') {
                params.type = 'ADD_CRC';
            } else if (type === 'newEmployeeNum') {
                params.type = 'NEW_CRC';
            }
        } else if (type === 'newOnDutyConfirmFte') {
            url = API_URL.user.getUserList;
            params.type = 'NEW_ON_DUTY';
        } else if (type === 'investigationConfirmFte') {
            url = API_URL.user.getUserList;
            params.type = 'INV_CONFIRM_FTE';
        } else if (type === 'newEmployeeConfirmFte') {
            url = API_URL.user.getUserList;
            params.type = 'NEW_CRC_FTE';
        } else if (type === 'allInvHospitalNum' || type === 'underwayInvHospitalNum' || type === 'allInvDeptNum' || type === 'underwayInvDeptNum') {
            url = API_URL.user.getUserList;
            if (type === 'allInvHospitalNum') {
                params.type = 'HOSPITAL_ALL_NUM';
            } else if (type === 'underwayInvHospitalNum') {
                params.type = 'HOSPITAL_UNDERWAY_NUM';
            } else if (type === 'allInvDeptNum') {
                params.type = 'DEPT_ALL_NUM';
            } else if (type === 'underwayInvDeptNum') {
                params.type = 'DEPT_UNDERWAY_NUM';
            }
        }  else if (type === 'undertakeAllInvNum' || type === 'undertakeUnderwayInvNum' || type === 'clinicalIAll' || type === 'clinicalIProcess'
        || type === 'clinicalIIAll' || type === 'clinicalIIProcess' || type === 'clinicalIIIAll' || type === 'clinicalIIIProcess'
        || type === 'clinicalIVAll' || type === 'clinicalIVProcess' || type === 'otherInvAll' || type === 'otherInvProcess'
        || type === 'tumourAllInvNum' || type === 'tumourUnderwayInvNum' || type === 'notTumourAllInvNum' || type === 'notTumourUnderwayInvNum' || type === 'intoGroupItemInvestigationNum'
        || type === 'comprehensiveAllNum' || type === 'comprehensiveUnderwayNum' || type === 'intoGroupMultiSiteInvNum') {
            url = API_URL.user.queryAnalysisDetailByDate;
            if (type === 'undertakeAllInvNum') {
                params.type = 'Investigation';
            } else if (type === 'undertakeUnderwayInvNum') {
                params.type = 'Investigation';
                params.inProgress = 1;
            } else if (type === 'clinicalIAll') {
                params.type = 'ClinicalOne';
            } else if (type === 'clinicalIProcess') {
                params.type = 'ClinicalOne';
                params.inProgress = 1;
            } else if (type === 'clinicalIIAll') {
                params.type = 'ClinicalTwo';
            } else if (type === 'clinicalIIProcess') {
                params.type = 'ClinicalTwo';
                params.inProgress = 1;
            } else if (type === 'clinicalIIIAll') {
                params.type = 'ClinicalThree';
            } else if (type === 'clinicalIIIProcess') {
                params.type = 'ClinicalThree';
                params.inProgress = 1;
            } else if (type === 'clinicalIVAll') {
                params.type = 'ClinicalFour';
            } else if (type === 'clinicalIVProcess') {
                params.type = 'ClinicalFour';
                params.inProgress = 1;
            } else if (type === 'otherInvAll') {
                params.type = 'ClinicalOther';
            } else if (type === 'otherInvProcess') {
                params.type = 'ClinicalOther';
                params.inProgress = 1;
            } else if (type === 'tumourAllInvNum') {
                params.type = 'Tumour';
            } else if (type === 'tumourUnderwayInvNum') {
                params.type = 'Tumour';
                params.inProgress = 1;
            } else if (type === 'notTumourAllInvNum') {
                params.type = 'NonTumour';
            } else if (type === 'notTumourUnderwayInvNum') {
                params.type = 'NonTumour';
                params.inProgress = 1;
            } else if (type == 'comprehensiveAllNum') {
                params.type = 'Comprehensive';
            } else if (type == 'comprehensiveUnderwayNum') {
                params.type = 'Comprehensive';
                params.inProgress = 1;
            } else if (type === 'intoGroupItemInvestigationNum') {
                params.type = 'IntoGroup';
            } else if (type === 'intoGroupMultiSiteInvNum') {
                params.type = 'IntoGroupMulti';
            }
        } else if (type === 'currentMonthTumourPatientNum' || type === 'currentMonthNotTumourPatientNum' || type === 'currentMonthComprehensivePatientNum') {
            url = API_URL.user.queryAnalysisDetailByDate;
            if (type === 'currentMonthTumourPatientNum') {
                params.type = 'TumourRandomAmount';
            } else if (type === 'currentMonthNotTumourPatientNum') {
                params.type = 'NonTumourRandomAmount';
            } else if (type === 'currentMonthComprehensivePatientNum') {
                params.type = 'ComprehensiveRandomAmount';
            }
        } else if (type === 'currentMonthTumourAddVisitNum' || type === 'currentMonthNotTumourAddVisitNum' || type === 'curMonthCompAddVisitNum') {
            url = API_URL.user.queryAnalysisDetailByDate;
            if (type === 'currentMonthTumourAddVisitNum') {
                params.type = 'TumourVisitAmount';
            } else if (type === 'currentMonthNotTumourAddVisitNum') {
                params.type = 'NonTumourVisitAmount';
            } else if (type === 'curMonthCompAddVisitNum') {
                params.type = 'CompVisitAmount';
            }
        } else if (type === 'currentMonthTumourStandardVisitCount' || type === 'currentMonthNotTumourStandardVisitCount' || type === 'curMonthCompStandVisitCount') {
            url = API_URL.user.queryAnalysisDetailByDate;
            if (type === 'currentMonthTumourStandardVisitCount') {
                params.type = 'StandardTumourVisitAmount';
            } else if (type === 'currentMonthNotTumourStandardVisitCount') {
                params.type = 'StandardNonTumourVisitAmount';
            } else if (type === 'curMonthCompStandVisitCount') {
                params.type = 'StandardCompVisitAmount';
            }
        } else if (type === 'newStartSiteNum') {
            url = API_URL.user.queryAnalysisDetailByDate;
            params.type = 'ActualSite';
        } else if (type === 'inGroupPatientNum') {
            url = API_URL.user.queryAnalysisDetailByDate;
            params.type = 'InGroupPatientNum';
        } else if (type === 'majorEventsNum') {
            url = API_URL.user.queryAnalysisDetailByDate;
            params.type = 'AnalysisMajorEvent';
        }
        const options = {
            method: 'POST',
            url,
            data: {
                limit: pageSize,
                offset: current,
                date: yearMonth,
                ...params,
                cityId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    pagination,
                    loading: false,
                    data: datas,
                });
            }
        };
        $.sendRequest(options);
    }

    getRender = (type, options) => {
        if (type === 'date') {
            return text => text ? text.slice(0, 10) : '';
        } else if (type === 'toChinese') {
            // 转中文
            const { contrastList } = options;
            return (text, record) => {
                return text ? (contrastList.find(i => i.value === text) || {}).name : '';
            }
        }
    }

    handleStringLinefeed = (text) => {
        const arr = (text || '').split('；');
        const result = arr.map((item, index) => {
            return <span key={index}>{item}{index < arr.length - 1 ? ';' : ''}<br /></span>;
        });
        return result;
    }


    getColumns = () => {
        const { type } = this.state;
        const columns = [];

        if (type === 'crcNum' || type === 'aboveSupervisorNum' || type === 'crcAddNum' || type === 'newEmployeeNum') {
            columns.push({
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
                fixed: 'left',
            }, {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 80,
                fixed: 'left',
            }, {
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 80,
                fixed: 'left',
            }, {
                title: '主管领导',
                dataIndex: 'leaderName',
                key: 'leaderName',
                width: 80,
            }, {
                title: '职位',
                dataIndex: 'positionName',
                key: 'positionName',
                width: 120,
            }, {
                title: '部门',
                dataIndex: 'enterpriseDepartmentName',
                key: 'enterpriseDepartmentName',
                width: 100,
            }, {
                title: '入职时间',
                dataIndex: 'joinTime',
                key: 'joinTime',
                width: 80,
                render: this.getRender('date'),
            }, {
                title: '目前状态',
                dataIndex: 'workStatus',
                key: 'workStatus',
                width: 80,
                render: (text, record) => {
                    const { leftTime } = record;
                    if (text === 'WORKING') {
                        return '在职';
                    } else {
                        return (
                            <span>离职<br />{leftTime ? leftTime.slice(0 ,10) : ''}</span>
                        );
                    }
                },
            });
        } else if (type === 'newOnDutyConfirmFte') {
            columns.push({
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
                fixed: 'left',
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 200,
                fixed: 'left',
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 260,
                fixed: 'left',
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '本月项目确认FTE',
                dataIndex: 'fte',
                key: 'fte',
                width: 140,
            });
        } else if ((type === 'investigationConfirmFte') || (type === 'newEmployeeConfirmFte')) {
            columns.push({
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
                fixed: 'left',
            }, {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 80,
                fixed: 'left',
            }, {
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 80,
                fixed: 'left',
            }, {
                title: '部门',
                dataIndex: 'enterpriseDepartmentName',
                key: 'enterpriseDepartmentName',
                width: 80,
                fixed: 'left',
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 140,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 200,
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '角色',
                dataIndex: 'roleCode',
                key: 'roleCode',
                width: 80,
            }, {
                title: '项目确认FTE',
                dataIndex: 'fte',
                key: 'fte',
                width: 100,
            });
        } else if (type === 'allInvHospitalNum' || type === 'underwayInvHospitalNum' || type === 'allInvDeptNum' || type === 'underwayInvDeptNum') {
            columns.push({
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
                fixed: 'left',
            }, {
                title: '医院名称',
                dataIndex: 'hospitalName',
                key: 'hospitalName',
                width: 120,
                fixed: 'left',
            }, {
                title: '科室',
                dataIndex: 'departmentLocalName',
                key: 'departmentLocalName',
                width: 80,
                fixed: 'left',
            }, {
                title: 'JDE主项目号',
                dataIndex: 'jdeMainCode',
                key: 'jdeMainCode',
                width: 100,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 140,
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '项目阶段',
                dataIndex: 'stageNames',
                key: 'stageNames',
                width: 80,
            }, {
                title: '项目计划开始时间',
                dataIndex: 'investigationPlanBeginTime',
                key: 'investigationPlanBeginTime',
                width: 100,
                render: this.getRender('date'),
            }, {
                title: '项目计划结束时间',
                dataIndex: 'investigationPlanEndTime',
                key: 'investigationPlanEndTime',
                width: 100,
                render: this.getRender('date'),
            }, {
                title: 'PM',
                dataIndex: 'pmNames',
                key: 'pmNames',
                width: 80,
            }, {
                title: '当月随机(入组)数量',
                dataIndex: 'randomAccount',
                key: 'randomAccount',
                width: 80,
            }, {
                title: '当月在组数量',
                dataIndex: 'patientsInProgressNum',
                key: 'patientsInProgressNum',
                width: 100,
            });
        } else if (type === 'undertakeAllInvNum' || type === 'undertakeUnderwayInvNum' || type === 'clinicalIAll' || type === 'clinicalIProcess'
        || type === 'clinicalIIAll' || type === 'clinicalIIProcess' || type === 'clinicalIIIAll' || type === 'clinicalIIIProcess'
        || type === 'clinicalIVAll' || type === 'clinicalIVProcess' || type === 'otherInvAll' || type === 'otherInvProcess'
        || type === 'tumourAllInvNum' || type === 'tumourUnderwayInvNum' || type === 'notTumourAllInvNum' || type === 'notTumourUnderwayInvNum' 
        || type === 'comprehensiveAllNum' || type === 'comprehensiveUnderwayNum') {
            columns.push({
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
                fixed: 'left',
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 160,
                fixed: 'left',
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '项目编号',
                dataIndex: 'investigationCode',
                key: 'investigationCode',
                width: 100,
            }, {
                title: '项目阶段',
                dataIndex: 'stageNames',
                key: 'stageNames',
                width: 100,
            }, {
                title: '项目分类',
                dataIndex: 'investigationTypeName',
                key: 'investigationTypeName',
                width: 120,
            }, {
                title: '项目领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 80,
            }, {
                title: '疾病',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 100,
            }, {
                title: '领域leader',
                dataIndex: 'leaderNameCode',
                key: 'leaderNameCode',
                width: 100,
            }, {
                title: '研究产品类型',
                dataIndex: 'investigationMedicineName',
                key: 'investigationMedicineName',
                width: 100,
            }, {
                title: '项目分期',
                dataIndex: 'investigationByStageName',
                key: 'investigationByStageName',
                width: 100,
            }, {
                title: 'PM',
                dataIndex: 'pmUserCompellation',
                key: 'pmUserCompellation',
                width: 80,
            });
        } else if (type === 'intoGroupItemInvestigationNum' || type === 'intoGroupMultiSiteInvNum') {
            columns.push({
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
                fixed: 'left',
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 160,
                fixed: 'left',
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '项目编号',
                dataIndex: 'investigationCode',
                key: 'investigationCode',
                width: 100,
            }, {
                title: '项目阶段',
                dataIndex: 'stageNames',
                key: 'stageNames',
                width: 100,
            }, {
                title: '项目分类',
                dataIndex: 'investigationTypeName',
                key: 'investigationTypeName',
                width: 120,
            }, {
                title: '项目类型',
                dataIndex: 'investigationGlobalTypeShow',
                key: 'investigationGlobalTypeShow',
                width: 120,
            }, {
                title: '项目领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 80,
            }, {
                title: '疾病',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 100,
            }, {
                title: '领域leader',
                dataIndex: 'leaderNameCode',
                key: 'leaderNameCode',
                width: 100,
            }, {
                title: '研究产品类型',
                dataIndex: 'investigationMedicineName',
                key: 'investigationMedicineName',
                width: 100,
            }, {
                title: '项目分期',
                dataIndex: 'investigationByStageName',
                key: 'investigationByStageName',
                width: 100,
            }, {
                title: 'PM',
                dataIndex: 'pmUserCompellation',
                key: 'pmUserCompellation',
                width: 80,
            });

        } else if (type === 'currentMonthTumourPatientNum' || type === 'currentMonthNotTumourPatientNum' || type === 'currentMonthComprehensivePatientNum') {
            columns.push({
                title: '患者编号',
                dataIndex: 'patientCode',
                key: 'patientCode',
                width: 100,
                fixed: 'left',
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 160,
                fixed: 'left',
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '项目领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 80,
            }, {
                title: '疾病',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 80,
            }, {
                title: '领域leader',
                dataIndex: 'leaderNameCode',
                key: 'leaderNameCode',
                width: 100,
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 120,
            }, {
                title: '筛选时间',
                dataIndex: 'filterDate',
                key: 'filterDate',
                width: 80,
            }, {
                title: '随机(入组)时间',
                dataIndex: 'randomDate',
                key: 'randomDate',
                width: 100,
            });
        } else if (type === 'currentMonthTumourAddVisitNum' || type === 'currentMonthNotTumourAddVisitNum' || type === 'curMonthCompAddVisitNum') {
            columns.push({
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
                fixed: 'left',
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 200,
                fixed: 'left',
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '项目领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 80,
            }, {
                title: '疾病',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 100,
            }, {
                title: '领域leader',
                dataIndex: 'leaderNameCode',
                key: 'leaderNameCode',
                width: 100,
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 160,
            }, {
                title: '当月新增访视数',
                dataIndex: 'visitAmount',
                key: 'visitAmount',
                width: 100,
            });
        } else if (type === 'currentMonthTumourStandardVisitCount' || type === 'currentMonthNotTumourStandardVisitCount' || type === 'curMonthCompStandVisitCount') {
            columns.push({
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
                fixed: 'left',
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 200,
                fixed: 'left',
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '项目领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 80,
            }, {
                title: '疾病',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 100,
            }, {
                title: '领域leader',
                dataIndex: 'leaderNameCode',
                key: 'leaderNameCode',
                width: 100,
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 160,
            }, {
                title: '当月新增确认标准访视数',
                dataIndex: 'standardVisitCount',
                key: 'standardVisitCount',
                width: 100,
            });
        } else if (type === 'newStartSiteNum') {
            columns.push({
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
                fixed: 'left',
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 160,
                fixed: 'left',
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 200,
                fixed: 'left',
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '实际递交立项资料的日期',
                dataIndex: 'actualProjectDate',
                key: 'actualProjectDate',
                width: 120,
                render: this.getRender('date'),
            }, {
                title: '实际site启动日期',
                dataIndex: 'actualSiteDate',
                key: 'actualSiteDate',
                render: this.getRender('date'),
                width: 120,
            });
        } else if (type === 'inGroupPatientNum') {
            columns.push({
                title: '患者编号',
                dataIndex: 'patientCode',
                key: 'patientCode',
                width: 100,
                fixed: 'left',
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 160,
                fixed: 'left',
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 120,
            }, {
                title: '筛选时间',
                dataIndex: 'filterDate',
                key: 'filterDate',
                width: 80,
            }, {
                title: '随机(入组)时间',
                dataIndex: 'randomDate',
                key: 'randomDate',
                width: 100,
            });
        } else if (type === 'majorEventsNum') {
            columns.push({
                title: '重大事件单号',
                dataIndex: 'majorEventNumber',
                key: 'majorEventNumber',
                fixed: 'left',
                width: 120,
            }, {
                title: '报告类型',
                dataIndex: 'reportTypeShow',
                key: 'reportTypeShow',
                fixed: 'left',
                width: 80,
            }, {
                title: '事件归属类型',
                dataIndex: 'eventType',
                key: 'eventType',
                width: 160,
                render: this.handleStringLinefeed,
            }, {
                title: '事件发生时间',
                dataIndex: 'eventHappenDate',
                key: 'eventHappenDate',
                width: 100,
                render: this.getRender('date'),
            }, {
                title: '事件获知时间',
                dataIndex: 'eventKnowDate',
                key: 'eventKnowDate',
                width: 100,
                render: this.getRender('date'),
            }, {
                title: '事件报告时间',
                dataIndex: 'eventReportDate',
                key: 'eventReportDate',
                width: 100,
                render: this.getRender('date'),
            }, {
                title: '报告人',
                dataIndex: 'reportUserName',
                key: 'reportUserName',
                width: 80,
            }, {
                title: '上报PM/LM时间',
                dataIndex: 'reportToPmLmDate',
                key: 'reportToPmLmDate',
                width: 120,
                render: this.getRender('date'),
            }, {
                title: '上报QA时间',
                dataIndex: 'reportToQaDate',
                key: 'reportToQaDate',
                width: 100,
                render: this.getRender('date'),
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 120,
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '项目名称',
                dataIndex: 'investigationSpecialName',
                key: 'investigationSpecialName',
                width: 160,
            }, {
                title: '项目编号',
                dataIndex: 'investigationCode',
                key: 'investigationCode',
                width: 100,
            }, {
                title: '项目领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 120,
            }, {
                title: '疾病',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 80,
            }, {
                title: '领域leader',
                dataIndex: 'leaderNameCode',
                key: 'leaderNameCode',
                width: 100,
            }, {
                title: '研究产品类型',
                dataIndex: 'investigationMedicineTypeShow',
                key: 'investigationMedicineTypeShow',
                width: 100,
            }, {
                title: '给药方式',
                dataIndex: 'administrationModeName',
                key: 'administrationModeName',
                width: 100,
            }, {
                title: '申办方',
                dataIndex: 'sponsorName',
                key: 'sponsorName',
                width: 120,
            }, {
                title: 'CRO',
                dataIndex: 'croName',
                key: 'croName',
                width: 120,
            }, {
                title: '津石PM',
                dataIndex: 'pmNames',
                key: 'pmNames',
                width: 80,
            }, {
                title: '申办方PM',
                dataIndex: 'sponsorPm',
                key: 'sponsorPm',
                width: 80,
            }, {
                title: 'CRO PM',
                dataIndex: 'croPm',
                key: 'croPm',
                width: 80,
            }, {
                title: '涉及层面',
                dataIndex: 'influenceLevelShow',
                key: 'influenceLevelShow',
                width: 100,
            }, {
                title: '涉及研究中心',
                dataIndex: 'siteNames',
                key: 'siteNames',
                width: 120,
            }, {
                title: 'CRC',
                dataIndex: 'crcNameCodes',
                key: 'crcNameCodes',
                width: 120,
                render: this.handleStringLinefeed,
            }, {
                title: 'CRC直线主管',
                dataIndex: 'leaderNameCodes',
                key: 'leaderNameCodes',
                width: 120,
                render: this.handleStringLinefeed,
            }, {
                title: '重大事件发生类型',
                dataIndex: 'happenTypeShow',
                key: 'happenTypeShow',
                width: 240,
            }, {
                title: '重大事件风险等级',
                dataIndex: 'riskLevel',
                key: 'riskLevel',
                width: 80,
            }, {
                title: '重大事件可能造成的影响',
                dataIndex: 'possibleImpact',
                key: 'possibleImpact',
                width: 120,
                render: this.handleStringLinefeed,
            }, {
                title: '主要责任方',
                dataIndex: 'mainResponsible',
                key: 'mainResponsible',
                width: 80,
            }, {
                title: '与津石员工相关性',
                dataIndex: 'jsEmployeeRelevance',
                key: 'jsEmployeeRelevance',
                width: 80,
            }, {
                title: '项目或方案要求描述',
                dataIndex: 'projectSchemeDescription',
                key: 'projectSchemeDescription',
                width: 80,
            }, {
                title: '实际操作情况',
                dataIndex: 'actualOperation',
                key: 'actualOperation',
                width: 100,
            }, {
                title: '目前对受试者及研究中心的影响',
                dataIndex: 'impactToSubjectsSite',
                key: 'impactToSubjectsSite',
                width: 120,
            }, {
                title: '重大事件处理结束与否',
                dataIndex: 'majorDealIsEndShow',
                key: 'majorDealIsEndShow',
                width: 100,
            }, {
                title: '最终处理情况及影响',
                dataIndex: 'finalTreatmentImpact',
                key: 'finalTreatmentImpact',
                width: 140,
            }, {
                title: '备注',
                dataIndex: 'comments',
                key: 'comments',
                width: 160,
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const { current, pageSize } = pagination;
        const dataSource = data.map((item, index) => ({
            id: index,
            index: (current - 1 || 0) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { visible, loading, type, record, pagination } = this.state;
        const { yearMonth, areaName, cityName } = record;

        let title = '';
        if (type === 'crcNum' || type === 'aboveSupervisorNum' || type === 'crcAddNum' || type === 'newEmployeeNum') {
            if (type === 'crcNum') {
                title = 'CRC人数';
            } else if (type === 'aboveSupervisorNum') {
                title = '主管以上人数';
            } else if (type === 'crcAddNum') {
                title = 'CRC新增';
            } else if (type === 'newEmployeeNum') {
                title = '新人人数';
            }
        } else if (type === 'newOnDutyConfirmFte') {
            title = '当月新site上岗确认FTE';
        } else if (type === 'investigationConfirmFte' || type === 'newEmployeeConfirmFte') {
            if (type === 'investigationConfirmFte') {
                title = '项目确认FTE';
            } else if (type === 'newEmployeeConfirmFte') {
                title = '新人确认FTE';
            }
        } else if (type === 'allInvHospitalNum' || type === 'underwayInvHospitalNum' || type === 'allInvDeptNum' || type === 'underwayInvDeptNum') {
            if (type === 'allInvHospitalNum') {
                title = '医院覆盖量（所有累计项目）';
            } else if (type === 'underwayInvHospitalNum') {
                title = '医院覆盖量（进行中项目）';
            } else if (type === 'allInvDeptNum') {
                title = '科室覆盖量（所有累计项目）';
            } else if (type === 'underwayInvDeptNum') {
                title = '科室覆盖量（进行中项目）';
            }
        } else if (type === 'undertakeAllInvNum' || type === 'undertakeUnderwayInvNum' || type === 'clinicalIAll' || type === 'clinicalIProcess'
        || type === 'clinicalIIAll' || type === 'clinicalIIProcess' || type === 'clinicalIIIAll' || type === 'clinicalIIIProcess'
        || type === 'clinicalIVAll' || type === 'clinicalIVProcess' || type === 'otherInvAll' || type === 'otherInvProcess'
        || type === 'tumourAllInvNum' || type === 'tumourUnderwayInvNum' || type === 'notTumourAllInvNum' || type === 'notTumourUnderwayInvNum' || type === 'intoGroupItemInvestigationNum'
        || type === 'intoGroupMultiSiteInvNum' || type === 'comprehensiveAllNum' || type === 'comprehensiveUnderwayNum') {
            if (type === 'undertakeAllInvNum') {
                title = '承担项目数量（所有累计项目）';
            } else if (type === 'undertakeUnderwayInvNum') {
                title = '承担项目数量（进行中项目）';
            } else if (type === 'clinicalIAll') {
                title = '临床I期项目数（所有累计项目）';
            } else if (type === 'clinicalIProcess') {
                title = '临床I期项目（进行中项目）';
            } else if (type === 'clinicalIIAll') {
                title = '临床II期项目数（所有累计项目）';
            } else if (type === 'clinicalIIProcess') {
                title = '临床II期项目（进行中项目）';
            } else if (type === 'clinicalIIIAll') {
                title = '临床III期项目数（所有累计项目）';
            } else if (type === 'clinicalIIIProcess') {
                title = '临床III期项目（进行中项目）';
            } else if (type === 'clinicalIVAll') {
                title = '临床IV期项目数（所有累计项目）';
            } else if (type === 'clinicalIVProcess') {
                title = '临床IV期项目数（进行中项目）';
            } else if (type === 'otherInvAll') {
                title = '其他项目数（所有累计项目）';
            } else if (type === 'otherInvProcess') {
                title = '其他项目数（进行中项目）';
            } else if (type === 'tumourAllInvNum') {
                title = '肿瘤项目数量（所有累计项目）';
            } else if (type === 'tumourUnderwayInvNum') {
                title = '肿瘤项目数量（进行中项目）';
            } else if (type === 'notTumourAllInvNum') {
                title = '非肿瘤项目数量（所有累计项目）';
            } else if (type === 'notTumourUnderwayInvNum') {
                title = '非肿瘤项目数量（进行中项目）';
            } else if (type === 'comprehensiveAllNum') {
                title = '综合项目数（所有累计项目）';
            } else if (type === 'comprehensiveUnderwayNum') {
                title = '综合项目数（进行中项目）';
            } else if (type === 'intoGroupItemInvestigationNum') {
                title = '处于入组期项目数量（单中心项目）';
            } else if (type === 'intoGroupMultiSiteInvNum') {
                title = '处于入组期项目数量（多中心项目）';
            }
        } else if (type === 'currentMonthTumourPatientNum' || type === 'currentMonthNotTumourPatientNum' || type === 'currentMonthComprehensivePatientNum') {
            if (type === 'currentMonthTumourPatientNum') {
                title = '当月入组病例数（肿瘤项目）';
            } else if (type === 'currentMonthNotTumourPatientNum') {
                title = '当月入组病例数（非肿瘤项目）';
            } else if (type === 'currentMonthComprehensivePatientNum') {
                title = '当月入组病例数（综合项目）';
            }
        } else if (type === 'currentMonthTumourAddVisitNum' || type === 'currentMonthNotTumourAddVisitNum' || type === 'curMonthCompAddVisitNum') {
            if (type === 'currentMonthTumourAddVisitNum') {
                title = '当月新增访视数（肿瘤项目）';
            } else if (type === 'currentMonthNotTumourAddVisitNum') {
                title = '当月新增访视数（非肿瘤项目）';
            } else if (type === 'curMonthCompAddVisitNum') {
                title = '当月新增访视数（综合项目）';
            }
        } else if (type === 'currentMonthTumourStandardVisitCount' || type === 'currentMonthNotTumourStandardVisitCount' || type === 'curMonthCompStandVisitCount') {
            if (type === 'currentMonthTumourStandardVisitCount') {
                title = '当月新增确认标准访视数（肿瘤项目）';
            } else if (type === 'currentMonthNotTumourStandardVisitCount') {
                title = '当月新增确认标准访视数（非肿瘤项目）';
            } else if (type === 'curMonthCompStandVisitCount') {
                title = '当月新增确认标准访视数（综合项目）';
            }
        } else if (type === 'newStartSiteNum') {
            title = '新启动中心数量';
        } else if (type === 'inGroupPatientNum') {
            title = '在组患者数量';
        } else if (type === 'majorEventsNum') {
            title = '重大事件发生数量';
        }
        return (
            <div>
                <Modal
                    title={title}
                    visible={visible}
                    onCancel={this.hide}
                    className="preview-modal"
                    width={1000}
                    footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
                >
                    <div className="cont" style={{ padding: 20 }}>
                        <div style={{marginBottom: 16}}>
                            时间：{yearMonth}
                            <span className="ant-divider" />
                            区域：{areaName}
                            <span className="ant-divider" />
                            城市：{cityName}
                        </div>
                        <TableC
                            loading={loading}
                            columns={this.getColumns()}
                            data={this.getDataSource()}
                            className="areaCityAnalysisDetail"
                            onChange={this.handleTableChange}
                            pagination={pagination}
                        />
                    </div>
                </Modal>
            </div>
        );
    }
}

export default DetailModal;


// WEBPACK FOOTER //
// ./src/components/user/areaCityAnalysis/DetailModal.js